import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';

// The code editor (Monaco) triggers a harmless browser warning, "ResizeObserver loop ...", which the
// React dev server shows as a full-screen red error. It never appears in production builds; hide it in dev.
const isResizeObserverNoise = (message) =>
  typeof message === 'string' && message.includes('ResizeObserver loop');
window.addEventListener('error', (e) => {
  if (isResizeObserverNoise(e.message)) {
    e.stopImmediatePropagation();
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    if (overlay) overlay.style.display = 'none';
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
